<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <money-boxes></money-boxes>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import MoneyBoxes from './MoneyBox/MoneyBoxes.vue'

  export default {
    components: {
      MoneyBoxes
    }
  }

</script>
<style>

</style>
